import { initializeApp } from 'firebase/app';
import { getAuth } from 'firebase/auth';
import { getFirestore } from 'firebase/firestore';

// Your Firebase configuration
const firebaseConfig = {
  apiKey: "AIzaSyCCNy_TEKsbYm-XTsm9s5Ew8_MZxO1s5Q4",
  authDomain: "literally-possible.firebaseapp.com",
  projectId: "literally-possible",
  storageBucket: "literally-possible.appspot.com",
  messagingSenderId: "490883243221",
  appId: "1:490883243221:web:f3436fb7cd25887c9e965c",
  databaseURL: "https://literally-possible-default-rtdb.firebaseio.com",
  measurementId: "G-M6G4W7ELTW"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);

// Initialize Firebase Authentication and get a reference to the service
export const auth = getAuth(app);

// Initialize Cloud Firestore and get a reference to the service
export const db = getFirestore(app);

export default app; 